import Button from '../../core/view/ui/Button';
import LayoutElement from '../../core/view/model/LayoutElement';
import {Circle, Container, Ellipse, Polygon, Rectangle, RoundedRectangle, Text} from 'pixi.js';
import {degToRad} from '../../core/utils/Utils';
import ButtonSpinAnimation from './ButtonSpinAnimation';
import { Tweener } from '../../core/tweener/engineTween';
import AssetsManager from '../../core/assets/AssetsManager';
// import Translation from '../../core/translations/Translation';
import SlotMachine from '../../slots/model/SlotMachine';
import { container } from 'tsyringe';


export default class ButtonSpin extends Button {
    // VISUALS
    // public pattern: Sprite;
    public buttonAnimator: ButtonSpinAnimation;

    private currentAnim: string;
    private spinText: Text;
    private countText: Text;

    /* eslint-disable */
    constructor(le: LayoutElement, customClassResolver: (le: LayoutElement) => any = null, hitArea: Rectangle | Circle | Ellipse | Polygon | RoundedRectangle = null) {
        super(le, customClassResolver, hitArea);

        this.buttonAnimator = (this.normal as ButtonSpinAnimation);
        
        this.spinText = new Text(AssetsManager.translations.get('tfSpinButton'), {
            fontFamily: AssetsManager.getWebFontFamily('InterRegular'),
            fontSize: 18,
            fontWeight: 'bold',
            fill: ['#CE0F0F']
        });
        this.spinText.anchor.set(0.5);
        this.spinText.y = 52;
        this.spinText.visible = false;

        // Add the spin text to the button animator, it is a placeholder in the spine animation

        const spinTextSlotIndex = this.buttonAnimator.skeleton.findSlotIndex('placeholder1');
        if (spinTextSlotIndex !== -1) {
            const spinBtnTextContainer = this.buttonAnimator.slotContainers[spinTextSlotIndex];
            spinBtnTextContainer.name = 'SpinBtnTextContainer';
            spinBtnTextContainer.removeChildren();
            spinBtnTextContainer.addChild(this.spinText);
        } else {
            this.buttonAnimator.addChild(this.spinText);
        }

        this.countText = new Text('', {
            fontFamily: AssetsManager.getWebFontFamily('InterRegular'),
            fontSize: 32,
            fontWeight: 'bold',
            fill: ['#CE0F0F']
        });
        this.countText.anchor.set(0.5);

        // Add the auto spin count text to the button animator, it is a placeholder in the spine animation

        const autoSpinSlotIndex = this.buttonAnimator.skeleton.findSlotIndex('placeholder2');
        if (autoSpinSlotIndex !== -1) {
            const autoSpinCounter: Container = this.buttonAnimator.slotContainers[autoSpinSlotIndex];
            autoSpinCounter.name = 'AutoSpinCounter';
            autoSpinCounter.removeChildren();
            autoSpinCounter.addChild(this.countText);
        } else {
            this.buttonAnimator.addChild(this.countText);
        }
    }

    // PRIVATE API
    protected customClassElementCreate(le: LayoutElement): unknown {
        let instance: unknown = null;

        switch (le.customClass) {
            case 'ButtonSpinAnimation':
                instance = new ButtonSpinAnimation();
                break;
            default:
                instance = super.customClassElementCreate(le);
                break;
        }

        return instance;
    }
    public removeTweens():void{
        this.buttonAnimator.visible = false
        this.buttonAnimator.state.setEmptyAnimations(0)
    }
    // Add the stop animation before the wait animation to the button animator
    
    public waitAnimation(waitAnimation: string): void {
        const isSpinning = this.currentAnim === ButtonSpinAnimation.SPIN
        const isStopping = this.currentAnim === ButtonSpinAnimation.STOP;

        this.currentAnim = '';
        if (isSpinning) { // If the button is spinning, we need to add stop animation before adding the wait animation
            this.buttonAnimator.setAnimation(ButtonSpinAnimation.STOP);
            this.buttonAnimator.addAnimation(waitAnimation, 0);
        } else if (isStopping) { // If the button is stopping(for the intoscreen and first mainscreen loading cases), we need to add the wait animation
            this.buttonAnimator.addAnimation(waitAnimation, 0);
        } else {
            this.buttonAnimator.setAnimation(waitAnimation);
        }
    }

    public playStopAnimation(): void {
        const isSpinning = this.currentAnim === ButtonSpinAnimation.SPIN
        if (!isSpinning) return;
        this.spinAnimation(ButtonSpinAnimation.STOP);
    }

    public spinAnimation(anim: string, addRotation: boolean = false): void {
        if (this.currentAnim === anim) return;

        this.buttonAnimator.setAnimation(anim);
        this.buttonAnimation(addRotation);
        this.currentAnim = anim;
    }

    private buttonAnimation(addRotation: boolean = false): void {
        Tweener.removeTweens(this.scale);
        Tweener.removeTweens(this.normal);

        this.normal.rotation = 0;

        Tweener.addTween(this.scale, {
            x: 0.83,
            y: 0.83,
            time: 0.1,
            transition: 'easeOutSine'
        });

        Tweener.addTween(this.scale, {
            x: 1,
            y: 1,
            time: 0.65,
            delay: 0.1,
            transition: 'easeOutBounce'
        });

        if (addRotation) {
            Tweener.addTween(this.normal, {
                rotation: degToRad(360),
                time: 0.35,
                transition: 'easeOutQuad',
                onComplete: () => {
                    this.normal.rotation = 0;
                }
            });
        }
    }

    public updateSpinCount(count: string): void {
        this.countText.text = count;
    }

    public hideOrShowStopText() {
        const sm = container.resolve(SlotMachine);
        if(sm.autoplay.enabled) {
            this.spinText.visible = true;
        } else {
            this.spinText.visible = false;
        }
    }
}
